
'use client';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { currentQuestionnaireInfo, currentTab, Section } from '../questions';
import { Box, LinearProgress } from '@mui/material';
import cssStyles  from "./questioniar_component.module.scss";


const QuestionIndicator = (sectionsInfoData: Array<Section>, currentTab: currentTab, currentQuestionnaireInfo: currentQuestionnaireInfo,fromFirstFlow:boolean=false) => {
    const jsxElements = []
    let length = 0;
    try{
      length =fromFirstFlow?3: sectionsInfoData[currentTab.index].count;
    }catch(e){}
    for(let i=0;i < length;i++){
      jsxElements.push(<Box  key={'QuestionIndicator_'+i} component="span" sx={{
        width: (100/length)+'%',
        '&:after': {
          backgroundColor:(fromFirstFlow?((currentQuestionnaireInfo.previousQuestionSequence-2) > i) :(currentQuestionnaireInfo.previousQuestionSequence > i) )? 'primary.main' : 'secondary.light'
        },
        '&:before': {
          backgroundColor: i === 0 ? 'primary.main' : 'secondary.light'
        }
      }} className={cssStyles["indicator-dots"]}></Box>)
      //jsxElements.push( (i < currentQuestionnaireInfo.questionSequence) ? <FiberManualRecordRoundedIcon className='indicator-item' style={{fontSize: '12px'}} key={i}/>:<RadioButtonUncheckedIcon style={{fontSize: '10px'}} className='indicator-item' key={i}/>);
    }
    jsxElements.push(<LinearProgress variant="determinate" value={100/length*(fromFirstFlow?currentQuestionnaireInfo.questionSequence-2:currentQuestionnaireInfo.questionSequence)} />)
    return jsxElements;
  }

export default QuestionIndicator;  